/* =========================================================
   OVERTOP — Canonical Product Redirect (Horizon)
   ---------------------------------------------------------
   Rewrites /collections/{handle}/products/{handle} →
   /products/{handle} so URLs stay clean for indexing & shares.

   Theme-agnostic.
   ========================================================= */

(function () {
  // Use the body's data-template-prefix or a static '/'
  // Horizon doesn't expose theme.routes globally, so use root '/'.
  var basePrefix = '';

  function redirectIfCollectionProductUrl() {
    var path = window.location.pathname || '';
    if (path.indexOf(basePrefix + '/collections/') === 0 && path.indexOf('/products/') !== -1) {
      var idx = path.indexOf('/products/');
      if (idx === -1) return;

      var after = path.substring(idx + '/products/'.length);
      var handle = (after.split('/')[0] || '').trim();
      if (!handle) return;

      var qs = window.location.search || '';
      var hash = window.location.hash || '';
      var target = basePrefix + '/products/' + handle + qs + hash;

      var current = path + qs + hash;
      if (current !== target) window.location.replace(target);
    }
  }

  redirectIfCollectionProductUrl();

  var _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    redirectIfCollectionProductUrl();
  };

  var _replaceState = history.replaceState;
  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    redirectIfCollectionProductUrl();
  };

  window.addEventListener('popstate', redirectIfCollectionProductUrl);
})();
